import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Container from 'components/ui/Container';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import { useFormik } from 'formik';
import useToggle from 'hooks/useToggle';
import { useState } from 'react';
import { toast } from 'react-toastify';
import {
  useCreateCertificateSignatureMutation,
  useDeleteCertificateSignatureMutation,
  useUpdateCertificateSignatureMutation
} from 'redux/reducers/signature';
import CertificateSignatureForm from './CertificateSignatureForm';
import CertificateSignatureTable from './CertificateSignatureTable';
import {
  certificateSignatureInitialValues,
  certificateSignatureSchemaValidation,
  ICertificateSignatureInput
} from './schema';

const CertificateSignature = () => {
  const [formModal, setFormModal] = useToggle(false);
  const [deleteModal, toggleDeleteModal] = useToggle(false);

  const [courseCategoryInitialFormState, setCourseCategoryInitialForm] = useState(
    certificateSignatureInitialValues
  );
  const [deletingCourseCategoryState, setDeletingCourseCategory] =
    useState<ICertificateSignatureInput | null>(null);

  const [deleteCourseCategory, { isLoading: isDeleting }] = useDeleteCertificateSignatureMutation();
  const [createCourseCategory, { isLoading: isCreating }] = useCreateCertificateSignatureMutation();
  const [updateCourseCategory, { isLoading: isUpdating }] = useUpdateCertificateSignatureMutation();
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: certificateSignatureSchemaValidation,
    initialValues: courseCategoryInitialFormState,
    onSubmit: (values) => {
      let executeFunc = createCourseCategory;
      if (values.id) {
        executeFunc = updateCourseCategory;
      }
      executeFunc(values)
        .unwrap()
        .then((data: any) => {
          toast.success(data?.message || 'Created Successfully');
          setCourseCategoryInitialForm(certificateSignatureInitialValues);
          setFormModal();
        })
        .catch((err: any) => {
          toast.error(err?.data?.message || 'Error  creating category');
        });
    }
  });

  const onEditClicked = (data: ICertificateSignatureInput) => {
    setCourseCategoryInitialForm(data);
    setFormModal();
  };

  const onDeleteConfirm = () => {
    deletingCourseCategoryState &&
      deleteCourseCategory(deletingCourseCategoryState?.id)
        .unwrap()
        .then((data: any) => {
          toast.success(data?.message || 'Deleted Successfully');
          setCourseCategoryInitialForm(certificateSignatureInitialValues);
          toggleDeleteModal();
        })
        .catch((err: any) => {
          toast.error(err?.data?.message || 'Error deleting course category');
        });
  };

  const onDeleteClicked = (data: ICertificateSignatureInput) => {
    setDeletingCourseCategory(data);
    toggleDeleteModal();
  };

  const closeModal = () => {
    setFormModal();
    setCourseCategoryInitialForm(certificateSignatureInitialValues);
  };

  return (
    <Container title="Certificate Signature" subTitle="List of all Certificate Signature">
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirm}
        title="Delete Confirmations"
        isLoading={isDeleting}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>
      <CertificateSignatureTable
        tableHeaders={() => (
          <div>
            <PrimaryButton
              title="Create Certificate Signature"
              iconName="ri-add-line align-bottom me-1"
              onClick={setFormModal}
              type="button"
            />
          </div>
        )}
        onEditClicked={onEditClicked}
        onDeleteClicked={onDeleteClicked}
      />

      <form onSubmit={formik.handleSubmit}>
        <Modal
          title={
            courseCategoryInitialFormState.id
              ? 'Update Certificate Signature'
              : 'Create Certificate Signature'
          }
          isModalOpen={formModal}
          closeModal={closeModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <SecondaryButton
                onClick={closeModal}
                title="Close"
                isLoading={isUpdating || isCreating}
              />
              <PrimaryButton
                title={courseCategoryInitialFormState.id ? 'Update' : 'Create'}
                iconName={`${
                  courseCategoryInitialFormState.id ? '' : 'ri-add-line'
                } align-bottom me-1`}
                type="submit"
                isLoading={isUpdating || isCreating}
              />
            </div>
          )}>
          <CertificateSignatureForm formik={formik} />
        </Modal>
      </form>
    </Container>
  );
};

export default CertificateSignature;
